"use client";

import React from "react";
import { Award, Heart, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "12+",
  label: "Global Communities",
  icon: Users
}, {
  value: "100%",
  label: "Impact Transparency",
  icon: Award
}];
export default function InvestInOurFuture() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="105886" id="the-philanthropy-fund" className="py-20 md:py-32 bg-background text-foreground relative overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="space-y-10">
            <div className="space-y-6">
              <Badge variant="outline" className="bg-primary/10 text-primary border-primary/20 px-4 py-1.5 text-sm rounded-sm">
                Current Project: Cuba
              </Badge>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-secondary leading-[1.1] tracking-wider">
                Do Well, and <br className="hidden md:block" />
                <span className="text-foreground">Do Good</span>
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl font-sans">
                At PS Travel Company, we believe in leaving every destination better than we found it. A dedicated percentage of every experience you book goes directly to our Philanthropy Fund, providing humanitarian aid, medical supplies, and educational resources to the communities that welcome us.
              </p>
            </div>

            {}
            <div className="grid grid-cols-2 gap-8 py-8 border-y border-border/20">
              {stats.map((stat, i) => <div key={i} data-index={i} className="space-y-3">
                  <stat.icon className="size-6 text-primary" />
                  <div className="text-4xl md:text-5xl font-bold text-secondary font-default tracking-tight">
                    {stat.value}
                  </div>
                  <div className="text-sm md:text-base font-medium text-foreground font-sans">
                    {stat.label}
                  </div>
                </div>)}
            </div>

            {}
            <div className="space-y-5 bg-card/40 p-6 md:p-8 rounded-sm border border-border/30 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl -mr-10 -mt-10 pointer-events-none" />
              
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4 relative z-10">
                <div>
                  <h4 className="text-lg font-bold text-secondary font-default">Cuba Relief Initiative</h4>
                  <p className="text-sm text-muted-foreground mt-1">Medical & School Supply Fund</p>
                </div>
                <div className="text-left sm:text-right">
                  <span className="text-2xl font-bold text-primary">$15,000</span>
                  <span className="text-sm text-muted-foreground font-medium"> / $20,000</span>
                </div>
              </div>
              
              <div className="relative z-10 space-y-2">
                <Progress value={75} className="h-2 bg-muted rounded-none" />
                <p className="text-xs font-medium text-muted-foreground text-right font-sans">
                  75% of our quarterly goal reached
                </p>
              </div>
            </div>

            {}
            <div className="pt-2">
              <Button asChild size="lg" className="rounded-sm px-8 h-14 text-base shadow-lg shadow-primary/10 transition-transform hover:-translate-y-1 bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="#">
                  <Heart className="mr-2 size-5 fill-current" />
                  Support the Mission
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative lg:pl-10 mt-10 lg:mt-0">
            {}
            <div className="relative rounded-sm overflow-hidden shadow-xl aspect-[4/5] md:aspect-[4/3] lg:aspect-[4/5] z-10 group">
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent z-10 opacity-60 transition-opacity group-hover:opacity-40" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/youth_award_fair_ceremony.png" alt="Humanitarian aid delivery in local community" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 desaturate-[0.2]" />
            </div>
            
            {}
            <div className="absolute -bottom-8 -left-4 md:left-8 lg:-left-8 z-20 bg-card/95 backdrop-blur-md p-6 rounded-sm shadow-2xl border border-border/30 max-w-[280px] animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-300 fill-mode-both">
              <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-secondary mt-1">
                  <Award className="size-5" />
                </div>
                <div>
                  <p className="text-sm font-bold text-secondary font-default mb-1">Leaving it Better</p>
                  <p className="text-xs text-muted-foreground leading-relaxed font-sans">
                    Fostering a global connection through meaningful, sustainable impact.
                  </p>
                </div>
              </div>
            </div>

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-primary/10 via-secondary/5 to-transparent rounded-full blur-3xl -z-10 pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}